export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 4812.66,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1224/marathon-invests-150-million-in-bitcoin"
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 5134.2,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1234/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 5292,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1238/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 5518,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1245/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 5784,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1247/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 6225.6,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1252/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 6695,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1256/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 7035,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1259/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 0,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1198/marathon-patent-group-announces-2020-fiscal-first-quarter"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 0,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1214/marathon-patent-group-announces-2020-fiscal-third-quarter"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 126,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1230/marathon-reports-fourth-quarter-and-fiscal-year-2020-results"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 5129.8,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1240/marathon-reports-first-quarter-2021-results"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 5784,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1254/marathon-digital-holdings-reports-second-quarter-2021"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 7035,
    source: "https://ir.marathondh.com/news-events/press-releases/detail/1259/marathon-digital-holdings-announces-bitcoin-production-and"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
